import { Location } from '@cobliteam/common-types';
import { lazy } from '@cobliteam/lazy-with-retries';

const FinesPage = lazy(() => import('@cobliteam/fines'));

const routes = [
  {
    path: Location.FINES,
    team: 'squad-gf-core',
    component: FinesPage,
    accessDeniedDescription: 'ver multas',
  },
];

export default routes;
